"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var services_1 = require("../../../services");
var sis_integer_settings_component_1 = require("./sis-integer-settings.component");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
var of_1 = require("rxjs/observable/of");
var MAX_32_BIT_INTEGER = 2147483647;
var MIN_32_BIT_INTEGER = -2147483648;
var SisIntegerComponent = /** @class */ (function (_super) {
    __extends(SisIntegerComponent, _super);
    function SisIntegerComponent(formattingService) {
        var _this = _super.call(this) || this;
        _this.formattingService = formattingService;
        _this.isReadonly = false;
        _this.toFormat = true;
        //
        _this.valueChange = new core_1.EventEmitter();
        _this._min = MIN_32_BIT_INTEGER;
        _this._max = MAX_32_BIT_INTEGER;
        return _this;
    }
    Object.defineProperty(SisIntegerComponent.prototype, "maxLength", {
        get: function () {
            return this._maxLength;
        },
        set: function (val) {
            if (val !== null && val !== undefined) {
                this._maxLength = val;
                this._maxLengthAfterFormat = val;
            }
            else {
                this._maxLength = 10;
                this._maxLengthAfterFormat = 10;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisIntegerComponent.prototype, "max", {
        set: function (val) {
            if (val !== undefined && val !== '') {
                this._max = +val;
            }
            else {
                this._max = MAX_32_BIT_INTEGER;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisIntegerComponent.prototype, "min", {
        set: function (val) {
            if (val !== undefined && val !== '') {
                this._min = +val;
            }
            else {
                this._min = MIN_32_BIT_INTEGER;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisIntegerComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (value || value === 0) {
                this._value = value + '';
                this.checkValue(true, this.toFormat);
            }
            else {
                this._value = '';
                this.valueChange.emit(null);
            }
        },
        enumerable: true,
        configurable: true
    });
    SisIntegerComponent.prototype.handleKeyPress = function (evt) {
        if (evt.which < 48 || evt.which > 57) {
            var eventTarget = evt.target;
            var selection = this._value.substring(eventTarget.selectionStart, eventTarget.selectionEnd);
            if (!(evt.which === 45 &&
                eventTarget.selectionStart === 0 &&
                (this._value.indexOf('-') === -1 ||
                    selection.indexOf('-') !== -1))) {
                evt.preventDefault();
            }
        }
    };
    Object.defineProperty(SisIntegerComponent.prototype, "maxLengthAfterFormat", {
        get: function () {
            return this._maxLengthAfterFormat;
        },
        enumerable: true,
        configurable: true
    });
    SisIntegerComponent.prototype.getIsReadonly = function () {
        return this.isReadonly;
    };
    SisIntegerComponent.prototype.blockPaste = function (e) {
        e.preventDefault();
    };
    SisIntegerComponent.prototype.checkValue = function (emit, format) {
        var _this = this;
        var nonNumericalSymbols = this._value.length - this._value.replace(/[^0-9]/g, '').length;
        this._maxLengthAfterFormat = this._maxLength + nonNumericalSymbols;
        if (this._value === '-') {
            return;
        }
        if (this._value === '') {
            this.valueChange.emit(null);
            return;
        }
        this.formattingService
            .parseNumber(this._value)
            .pipe(operators_1.mergeMap(function (number) {
            if (isNaN(number)) {
                return of_1.of(number);
            }
            else {
                var parsedValue_1 = Math.trunc(Math.min(Math.max(number, _this._min), _this._max));
                if (format) {
                    return _this.formattingService
                        .formatNumber(parsedValue_1)
                        .pipe(operators_1.map(function (formatted) {
                        _this._value = formatted;
                        _this._maxLengthAfterFormat =
                            _this._maxLength +
                                formatted.length -
                                parsedValue_1.toString().length;
                        return parsedValue_1;
                    }));
                }
                else {
                    return of_1.of(parsedValue_1);
                }
            }
        }), operators_1.first())
            .subscribe(function (number) {
            if (isNaN(number)) {
                _this.valueChange.emit(null);
                _this._value = '';
                return;
            }
            if (emit) {
                _this.valueChange.emit(number);
            }
        }, console.error);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisIntegerComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisIntegerComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SisIntegerComponent.prototype, "toFormat", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisIntegerComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], SisIntegerComponent.prototype, "maxLength", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisIntegerComponent.prototype, "max", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisIntegerComponent.prototype, "min", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisIntegerComponent.prototype, "value", null);
    __decorate([
        core_1.HostListener('paste', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], SisIntegerComponent.prototype, "blockPaste", null);
    SisIntegerComponent = __decorate([
        core_1.Component({
            selector: 'sis-integer',
            template: require('./sis-integer.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Integer',
            settings: {
                main: sis_integer_settings_component_1.SisIntegerSettingsComponent,
            },
            template: "\n                        <sis-integer [id]=\"'%{id}'\" [(value)]=\"%{field}\" [isReadonly]=\"%{isReadonly}\" [hint]=\"%{hint}\"\n                        [max]=\"%{max}\" [min]=\"%{min}\" [maxLength]=\"%{maxLength}\" [toFormat]=\"%{toFormat}\">\n                        </sis-integer>\n                   ",
            cellCount: 3,
            isFieldBound: true,
        }),
        __metadata("design:paramtypes", [services_1.FormattingService])
    ], SisIntegerComponent);
    return SisIntegerComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisIntegerComponent = SisIntegerComponent;
//# sourceMappingURL=sis-integer.component.js.map